export function Footer() {
  return (
    <footer className="mt-24 border-t border-border/60">
      <div className="max-w-6xl mx-auto py-10 container-px text-sm text-foreground/70 flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
        <p>© {new Date().getFullYear()} Mano Studio, Bangkok</p>
        <p>Crafted with care • Open by appointment • Instagram: @manostudio</p>
      </div>
    </footer>
  );
}
